module.exports = __webpack_public_path__ + "489304f99726558e6b36784a37d0bbd8.svg";